import { EntityState, Update } from '@ngrx/entity';

import { Artist } from '@shared/models/artist';
import { PreferencesAction, PreferencesActionTypes } from '../actions';
import { artistAdapter } from '../adapters';

export interface ArtistsState extends EntityState<Artist> {
  loading: boolean;
  nextPage: boolean;
  searchTerm: string;
  followingFilter: boolean;
  initialFilter: string;
}

export const initialArtistsState: ArtistsState = artistAdapter.getInitialState({
  loading: true,
  nextPage: false,
  searchTerm: '',
  followingFilter: false,
  initialFilter: '',
});

export function artistsReducer(state: ArtistsState = initialArtistsState, action: PreferencesAction): ArtistsState {
  switch (action.type) {
    case PreferencesActionTypes.LOAD_ARTISTS: {
      return {
        ...initialArtistsState,
      };
    }

    case PreferencesActionTypes.LOAD_ARTISTS_NEXT_PAGE: {
      return {
        ...state,
        loading: true,
      };
    }

    case PreferencesActionTypes.LOAD_ARTISTS_SUCCESS: {
      const newArtistsState: ArtistsState = {
        ...state,
        loading: false,
        nextPage: action.nextPage,
      };

      return artistAdapter.addMany(action.artists, newArtistsState);
    }

    case PreferencesActionTypes.LOAD_ARTISTS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case PreferencesActionTypes.ARTIST_INITIAL_FILTER_CHANGE: {
      return artistAdapter.removeAll({
        ...state,
        loading: true,
        nextPage: false,
        initialFilter:
          action.initialFilter === state.initialFilter ? initialArtistsState.initialFilter : action.initialFilter,
      });
    }

    case PreferencesActionTypes.ARTIST_SEARCH_TERM_CHANGE: {
      return artistAdapter.removeAll({
        ...state,
        loading: true,
        nextPage: false,
        searchTerm: action.searchTerm,
      });
    }

    case PreferencesActionTypes.ARTIST_FOLLOWING_FILTER_CHANGE: {
      return artistAdapter.removeAll({
        ...state,
        loading: true,
        nextPage: false,
        followingFilter: !state.followingFilter,
      });
    }

    case PreferencesActionTypes.TOGGLE_PREFERENCE: {
      const update: Update<Artist> = {
        id: action.id,
        changes: {
          is_preferred: !state.entities[action.id]?.is_preferred,
        },
      };

      return artistAdapter.updateOne(update, { ...state });
    }

    default:
      return state;
  }
}
